// material-ui

import semitrailer2 from '../../../assets/images/Trailer/semitrailer2.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Semitrailer2 = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={semitrailer2} alt="Semitrailer 2" height={20}  />
    );
};

export default Semitrailer2;